import React from "react";
import "../styles/About.css";
import "../styles/PrivacyPolicy.css";

const RefundPolicy = () => {
  return (
    <>
      <section className="banner_area">
        <div className="banner_inner d-flex align-items-center">
          <div className="overlay bg-parallax"></div>
          <div className="container">
            <div className="banner_content text-center">
              <h2>Refund & Cancellation Policy</h2>
              <div className="page_link">
                <a href="/">Home</a>
                <span className="breadcrumb-arrow">→</span>
                <a href="/refund-policy">Refund & Cancellation Policy</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy_policy_area container py-5">
        <h3>Overview</h3>
        <p>
          At Learnific, we are committed to providing high-quality online
          courses, learning programs, and educational services. This Refund &
          Cancellation Policy explains the terms and conditions applicable to
          course purchases, subscriptions, cancellations, and refund requests.
        </p>

        <h3>Course Enrollment & Payment</h3>
        <p>
          Enrollment in a course or learning program is confirmed after
          successful payment. Once payment has been completed, users may
          receive immediate access to digital course materials, videos,
          assessments, live classes, or other educational resources depending
          on the selected course.
        </p>

        <h3>Cancellation Policy</h3>
        <p>
          Users may request cancellation of their course enrollment by
          contacting our support team within the applicable cancellation
          period specified for the respective course or program.
        </p>

        <p>
          Cancellation requests made after substantial access or consumption
          of course content may not be eligible for cancellation or refund.
        </p>

        <h3>Refund Eligibility</h3>
        <p>
          Refunds may be considered in the following circumstances:
        </p>

        <ul>
          <li>
            The refund request is submitted within the applicable refund
            period specified for the course.
          </li>
          <li>
            The course or service purchased is cancelled by Learnific.
          </li>
          <li>
            A technical issue attributable to Learnific prevents the user from
            accessing the purchased course or service and the issue cannot be
            reasonably resolved.
          </li>
          <li>
            Duplicate payment has been made for the same course or service.
          </li>
          <li>
            Any other refund eligibility specifically mentioned on the
            respective course or program enrollment page.
          </li>
        </ul>

        <h3>Non-Refundable Circumstances</h3>
        <p>
          Refunds may not be provided in the following circumstances:
        </p>

        <ul>
          <li>
            The user has substantially accessed, downloaded, or consumed the
            course content.
          </li>
          <li>
            The refund request is submitted after the applicable refund period.
          </li>
          <li>
            The user purchased the course by mistake but has already accessed
            the learning materials.
          </li>
          <li>
            The user is unable to complete the course due to personal,
            professional, or scheduling reasons.
          </li>
          <li>
            The user does not attend live classes despite having access to the
            scheduled sessions.
          </li>
          <li>
            The user fails to meet the requirements necessary to participate in
            a particular course or program.
          </li>
          <li>
            The account has been suspended or terminated due to violation of
            our Terms & Conditions or other applicable policies.
          </li>
        </ul>

        <h3>Digital Course Content</h3>
        <p>
          Since our courses may include digital content such as recorded
          lectures, e-books, study materials, assignments, quizzes, and
          downloadable resources, refunds may be restricted once such content
          has been accessed or downloaded by the user.
        </p>

        <h3>Live Classes & Instructor-Led Programs</h3>
        <p>
          For live classes, instructor-led programs, workshops, and
          cohort-based courses, refund and cancellation terms may vary
          depending on the program. The applicable terms displayed during
          enrollment will apply to the relevant course or program.
        </p>

        <h3>Subscription-Based Services</h3>
        <p>
          For subscription-based services, users may cancel their subscription
          before the next billing cycle to avoid future charges. Cancellation
          of a subscription does not automatically result in a refund for the
          current billing period unless otherwise stated in the applicable
          subscription terms.
        </p>

        <h3>Refund Request Process</h3>
        <p>
          To request a refund, users should contact our support team using the
          contact details provided below. The refund request should include:
        </p>

        <ul>
          <li>Registered name</li>
          <li>Registered email address</li>
          <li>Order or transaction ID</li>
          <li>Name of the purchased course or program</li>
          <li>Reason for requesting the refund</li>
          <li>Any supporting information, if applicable</li>
        </ul>

        <h3>Refund Processing</h3>
        <p>
          Once a refund request is received, our team will review the request
          and determine eligibility according to this policy and the
          applicable course-specific terms.
        </p>

        <p>
          If approved, the refund will generally be processed to the original
          payment method used for the transaction. The time required for the
          refunded amount to appear in the user's account may vary depending
          on the payment gateway, bank, card issuer, or other financial
          institution.
        </p>

        <h3>Duplicate Payments</h3>
        <p>
          If a user has accidentally made multiple payments for the same
          course or service, the duplicate transaction may be eligible for a
          refund after verification of the transaction details.
        </p>

        <h3>Course Cancellation by Learnific</h3>
        <p>
          If Learnific cancels a course, batch, live program, or other paid
          educational service and is unable to provide a suitable alternative,
          eligible users may receive a refund in accordance with the terms
          communicated for that particular program.
        </p>

        <h3>Promotional Offers & Discounts</h3>
        <p>
          Courses purchased using promotional offers, discounts, coupons, or
          special pricing may be subject to additional refund conditions.
          Unless specifically stated otherwise, promotional discounts and
          coupon benefits are not separately refundable or transferable.
        </p>

        <h3>Third-Party Services</h3>
        <p>
          Certain educational services, examinations, certifications,
          payment services, or third-party learning resources may be governed
          by separate refund policies of the respective third-party provider.
          In such cases, the applicable third-party terms may also apply.
        </p>

        <h3>Changes to This Refund Policy</h3>
        <p>
          Learnific reserves the right to modify or update this Refund &
          Cancellation Policy from time to time. Any changes will become
          effective when the updated policy is published on our website.
        </p>

        <h3>Contact Us</h3>
        <p>
          If you have any questions regarding cancellations, refunds, course
          purchases, or this policy, please contact our support team at:
          <br />
          <strong>vectorisadvisory@gmail.com</strong>
        </p>
      </section>
    </>
  );
};

export default RefundPolicy;